import { Selectors } from "../Selectors";

//import { Ajax } from "../Utils/Ajax";
declare var JEEFACEFILTERAPI: any;

export class FaceDetectionControllerFr {
    public alreadyRegistered: boolean = false;
    timeoutSnap: number | undefined;
    constructor(private webcamElement: HTMLVideoElement, private canvasElement: HTMLCanvasElement, private webcam: any,
        private leftSnap: boolean, private rightSnap: boolean, private upSnap: boolean, private downSnap: boolean, private straightSnap: boolean, private nccPath: boolean,
        private form: string) { }

    public init() {
        this.initWebcamListener();
    }

    public stopWebcam(){
        this.webcam.stop();
        JEEFACEFILTERAPI.destroy();
        clearTimeout(this.timeoutSnap);
        $(Selectors.generalStepSelector).hide();
        $(`div[class^='${Selectors.iconArrowGeneralSelector.substring(1)}']`).hide();
    }

    public reInitScan(){
        this.alreadyRegistered = false,
        this.straightSnap = false,
        this.leftSnap = false,
        this.rightSnap = false;
        this.downSnap = false,
        this.upSnap = false;
        let $possibleInputImages = $(this.form).find(`input[type='hidden'][name^='${Selectors.inputImagesName}']`);
        $possibleInputImages.remove();
    }

    private changeBtnRegisterMessage(number: number){
        let $spans = $(Selectors.buttonInitRegisterSelector).find("span");
        $spans.hide();
        $spans.eq(number).show();
    }

    private initWebcamListener() {
        let that = this;
        this.webcamElement.addEventListener('playing', () => {
            if(this.alreadyRegistered){
                this.reInitScan();
                this.changeBtnRegisterMessage(0);
            }
            if (this.webcamElement != null) {
                this.canvasElement.width = this.webcamElement.width;
                this.canvasElement.height = this.webcamElement.height;
            }
            let canvasDisplay: any = null;

            JEEFACEFILTERAPI.init({
                canvasId: Selectors.canvasSecondElementId,
                videoSettings: {
                    videoElement: this.webcamElement
                },
                NNCpath: that.nccPath, // root of NNC.json file
                callbackReady: function (errCode: any, spec: any) {
                    if (errCode) {
                        console.log('AN ERROR HAPPENS. SORRY BRO :( . ERR =', errCode);
                        return;
                    }
                    $(Selectors.personSvgSelector).hide();
                    //console.log('INFO: JEEFACEFILTERAPI IS READY');
                    canvasDisplay = JEEFACEFILTERAPI.Canvas2DDisplay(spec);
                    canvasDisplay.ctx.strokeStyle = 'yellow';
                },

                // called at each render iteration (drawing loop):
                callbackTrack: function (detectState: { detected: number; }) {
                    if (detectState.detected > 0.6) {
                        // draw a border around the face:
                        const faceCoo = canvasDisplay.getCoordinates(detectState);
                        const mv = that.compute_cameraMove(detectState);
                        canvasDisplay.ctx.clearRect(0, 0, canvasDisplay.canvas.width, canvasDisplay.canvas.height);
                        canvasDisplay.ctx.strokeRect(faceCoo.x, faceCoo.y, faceCoo.w, faceCoo.h);
                        canvasDisplay.update_canvasTexture();
                        if (mv.dRx !== 0 || mv.dRy !== 0 || mv.dZ !== 0) {
                            that.takeSnap(mv);
                        }
                    }
                    canvasDisplay.draw();
                }
            });
        })
    }

    private compute_cameraMove(detectState: { detected: any; rx?: any; ry?: any; s?: any; }) {
        const _defaultSettings = {
            detectionThreshold: 0.85, //sensibility, between 0 and 1. Less -> more sensitive
            detectionHysteresis: 0.05,
            tol: {
                rx: 5,//do not move if head turn more than this value (in degrees) from head rest position
                ry: 5,
                s: 5 //do not move forward/backward if head is larger/smaller than this percent from the rest position
            },
            sensibility: {
                rx: 1,
                ry: 1,
                s: 1
            }
        };
        let _settings = Object.assign({}, _defaultSettings, {});
        _settings.tol.rx *= Math.PI / 180; // convert from degrees to radians
        _settings.tol.ry *= Math.PI / 180;
        _settings.tol.s /= 100;
        const _returnValue = {
            dRx: 0, dRy: 0,
            dZ: 0
        };
        let _lastTimestamp = 0;
        let _disableRestPosition = false;

        const _state = {
            isLoaded: true,
            isDetected: false,
            isEnabled: true,
            restHeadPosition: { //position of the head matching with No Move
                needsUpdate: false,
                s: 0,
                rx: 0,
                ry: 0
            }
        };

        if (_state.isDetected && detectState.detected < _settings.detectionThreshold - _settings.detectionHysteresis) {
            // DETECTION LOST

            _state.isDetected = false;
            _returnValue.dRx = 0;
            _returnValue.dRy = 0;
            _returnValue.dZ = 0;
        } else if (!_state.isDetected && detectState.detected > _settings.detectionThreshold + _settings.detectionHysteresis) {
            // FACE DETECTED
            _state.isDetected = true;
        }

        if (!_state.isEnabled || !_state.isDetected || !_state.isLoaded) {
            return _returnValue; //no camera move
        }

        if (_state.restHeadPosition.needsUpdate && !_disableRestPosition) {
            _state.restHeadPosition.needsUpdate = false;
            _state.restHeadPosition.rx = detectState.rx;
            _state.restHeadPosition.ry = detectState.ry;
            _state.restHeadPosition.s = detectState.s;
            _lastTimestamp = Date.now();
        }

        // compute movement of the camera
        const ts = Date.now();
        const dt = ts - _lastTimestamp;
        _returnValue.dRx = dt * this.compute_delta(_state.restHeadPosition.rx, detectState.rx, _settings.tol.rx, _settings.sensibility.rx);
        _returnValue.dRy = dt * this.compute_delta(_state.restHeadPosition.ry, detectState.ry, _settings.tol.ry, _settings.sensibility.ry);
        _returnValue.dZ = dt * this.compute_delta(_state.restHeadPosition.s, detectState.s, _settings.tol.s, _settings.sensibility.s);

        _lastTimestamp = ts;
        return _returnValue;
    }

    private compute_delta(ref: number, val: number, tol: number, sensibility: number) {
        if (Math.abs(ref - val) < tol) {
            return 0;
        }
        return (val - ref) * sensibility;
    }

    private createSnap(i: number){
        let picture = this.webcam.snap();
        //$('body').append('<img class="snap" src="'+picture+'" />');
        var input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", `${Selectors.inputImagesName}[${i}]`);
        input.setAttribute("value", picture);
        $(this.form).append(input);
        i++;
        return i;
    }

    private takeSnap(mv: { dRx: any; dRy: any; dZ?: number; }) {
        let that = this;
        let i = 1;

        if (mv.dRy < 1e1 && mv.dRy > -1e1 && mv.dRx < 1e1 && mv.dRx > -1e1 && !this.straightSnap) {
            this.straightSnap = true;
            let j = i + 4;
            this.timeoutSnap = setTimeout(function () {
                while (i < j) {
                    i = that.createSnap(i);
                }
                if (i === j) {
                    that.registro_porcentaje_add();
                    $(`${Selectors.generalStepSelector}1`).hide();
                    $(`${Selectors.generalStepSelector}2`).show();
                    $(`${Selectors.iconArrowGeneralSelector}left`).fadeIn();
                }
            }, 2000);
        }

        //HANDLE LEFT/RIGHT :
        if (mv.dRy > 80e10 && Math.abs(mv.dRy) > Math.abs(mv.dRx) && !this.leftSnap && this.straightSnap) {
            this.leftSnap = true;
            i = 5;
            let j = i + 4;
            this.timeoutSnap = setTimeout(function () {
                while (i < j) {
                    i = that.createSnap(i);
                }
                if (i === j) {
                    that.registro_porcentaje_add();
                    $(`${Selectors.generalStepSelector}2`).hide();
                    $(`${Selectors.generalStepSelector}3`).show();
                    $(`${Selectors.iconArrowGeneralSelector}left`).hide();
                    $(`${Selectors.iconArrowGeneralSelector}right`).fadeIn();
                }
            }, 2000);
        } else if (mv.dRy < -80e10 && Math.abs(mv.dRy) > Math.abs(mv.dRx) && !this.rightSnap && this.leftSnap) {
            this.rightSnap = true;
            i = 9;
            let j = i + 4;
            this.timeoutSnap = setTimeout(function () {
                while (i < j) {
                    i = that.createSnap(i);
                }
                if (i === j) {
                    that.registro_porcentaje_add();
                    $(`${Selectors.generalStepSelector}3`).hide();
                    $(`${Selectors.generalStepSelector}4`).show();
                    $(`${Selectors.iconArrowGeneralSelector}right`).hide();
                    $(`${Selectors.iconArrowGeneralSelector}bottom`).fadeIn();
                }
            }, 2000);
        }

        //HANDLE UP/DOWN : 10 000 10e6
        if (mv.dRx > 65e10 && Math.abs(mv.dRx) > Math.abs(mv.dRy) && !this.downSnap && this.rightSnap) {
            this.downSnap = true;
            i = 13;
            let j = i + 4;
            this.timeoutSnap = setTimeout(function () {
                while (i < j) {
                    i = that.createSnap(i);
                }
                if (i === j) {
                    that.registro_porcentaje_add();
                    $(`${Selectors.generalStepSelector}4`).hide();
                    $(`${Selectors.generalStepSelector}5`).show();
                    $(`${Selectors.iconArrowGeneralSelector}bottom`).hide();
                    $(`${Selectors.iconArrowGeneralSelector}top`).fadeIn();
                }
            }, 2000);
        } else if (mv.dRx < -65e10 && Math.abs(mv.dRx) > Math.abs(mv.dRy) && !this.upSnap && this.downSnap) {
            this.upSnap = true;
            i = 17;
            let j = i + 4;
            this.timeoutSnap = setTimeout(function () {
                while (i < j) {
                    i = that.createSnap(i);
                }
                if (i === j) {
                    that.registro_porcentaje_add();
                    $(`${Selectors.generalStepSelector}5`).hide();
                    $(`${Selectors.iconArrowGeneralSelector}top`).hide();
                    that.alreadyRegistered = true;
                    setTimeout(function () {
                        $(Selectors.modalSelector).fadeOut(400, function(){
                            $(Selectors.modalOverlaySelector).hide();
                            that.stopWebcam();
                            that.changeBtnRegisterMessage(1);
                        });
                    }, 1500)
                }
            }, 2000);
        }
    }

    private registro_porcentaje_add() {
        let $registroPorcentaje = $(Selectors.registroPorcentajeSelector);
        let porcentaje = $registroPorcentaje.text();
        switch (porcentaje) {
            case "0%":
                $registroPorcentaje.text("20%");
                break;
            case "20%":
                $registroPorcentaje.text("40%");
                break;
            case "40%":
                $registroPorcentaje.text("60%");
                break;
            case "60%":
                $registroPorcentaje.text("80%");
                break;
            case "80%":
                $registroPorcentaje.text("100%");
                break;
            default:
                break;
        }
    }
}
